import { Injectable, inject, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

/**
 * ScrollLockService
 * Reference-counted body scroll locker so multiple components can request
 * a lock (e.g., sidebar, modal, chatbot) without stepping on each other.
 * SSR-safe with Renderer2 for DOM manipulation.
 */
@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);
  private renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);
  private lockCount = 0;
  private readonly className = 'body-scroll-locked';

  constructor() {}

  /** Acquire a scroll lock */
  lock(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.lockCount++;
    if (this.lockCount === 1 && this.document.body) {
      this.renderer.addClass(this.document.body, this.className);
    }
  }

  /** Release a scroll lock */
  unlock(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.lockCount > 0) {
      this.lockCount--;
      if (this.lockCount === 0 && this.document.body) {
        this.renderer.removeClass(this.document.body, this.className);
      }
    }
  }

  /** Force clear all locks (safety) */
  reset(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.lockCount = 0;
    if (this.document.body) {
      this.renderer.removeClass(this.document.body, this.className);
    }
  }
}
